import { IPartImage } from "../../models/Part";

const isStockPhoto = (image: IPartImage) => !image.deleted && !image.url?.includes("mp4") && !image.isEndSlate;

const byCaptureOrder = (images: IPartImage[]): IPartImage[] =>
  images
    .map((image, index) => ({ image, index }))
    .sort((a, b) => {
      const orderA = a.image.order ?? Number.MAX_SAFE_INTEGER;
      const orderB = b.image.order ?? Number.MAX_SAFE_INTEGER;
      return orderA - orderB || a.index - b.index;
    })
    .map(({ image }) => image);

/** Every stock photo. Videos and end slates are not photos you tick onto a listing. */
export function stockPhotos(images: IPartImage[] | undefined): IPartImage[] {
  return byCaptureOrder((images ?? []).filter(isStockPhoto));
}

/**
 * The photos eBay gets, in order. When any photo is ticked for the listing, only those go.
 * When none are ticked, every stock photo is on the listing — the same rule the listing path uses.
 */
export function orderedPhotos(images: IPartImage[] | undefined): IPartImage[] {
  const stock = stockPhotos(images);
  const selected = stock.filter((image) => image.useOnEbay);
  return selected.length > 0 ? selected : stock;
}
